import React, { ReactNode } from "react";
import { TableHeader } from "./TableHeader";
import { TableColumn } from "../../../types/table/TableColumn";
import Table from "react-bootstrap/Table";
import { Pagination } from "@mui/material";
import { OpcoesSelecionaveisCheckBox } from "types/OpcoesSelecionaveisCheckBoxType";

interface TableProps {
  id: string;
  children: ReactNode;
  colunas: TableColumn[];
  renderCheckBox: boolean;
  renderPagination?: boolean;
  tipoCheckBox?: "SELECT_OPTIONS" | "SELECT_ALL";
  onChangeCheckBox?: (opcao: OpcoesSelecionaveisCheckBox) => void;
  disabledCheckBox?: boolean;
  checkedCheckBox?: boolean;
  ordernarPorColuna?: string;
  ordenacaoAscOuDesc?: "ASC" | "DESC";
  onChangePageFunction: (paginaAtual: number) => void;
  ordenarRegistrosFunction?: (columnId: string) => void;
  paginaAtual: number;
  quantidadeDePaginas: number;
  isIndeterminateCheckBox?: boolean;
  quantidadeDeRegistros: number;
  isLoading: boolean;
}

export const Tabela: React.FC<TableProps> = ({
  renderPagination = true,
  ...props
}) => {
  const renderTableHeader = () => {
    return (
      <TableHeader
        id={props.id}
        colunas={props.colunas}
        ordenacaoAscOuDesc={props.ordenacaoAscOuDesc}
        ordernarPorColuna={props.ordernarPorColuna}
        ordenarRegistrosFunction={props.ordenarRegistrosFunction}
        renderCheckBox={props.renderCheckBox}
        tipoCheckBox={props.tipoCheckBox}
        onChangeCheckBox={props.onChangeCheckBox}
        disabledCheckBox={props.disabledCheckBox}
        isIndeterminateCheckBox={props.isIndeterminateCheckBox}
        checkedCheckBox={props.checkedCheckBox}
      />
    );
  };

  const renderTableBody = () => {
    return <tbody className={"table-body"}>{props.children}</tbody>;
  };

  const renderNenhumRegistro = () => {
    return (
      <div className={"nenhum-registro"}>
        <span>Nenhum registro foi encontrado</span>
      </div>
    );
  };

  const renderPaginacao = () => {
    return (
      <div className={"table-pagination"}>
        <Pagination
          size="small"
          onChange={(e, paginaAtual) => props.onChangePageFunction(paginaAtual)}
          page={props.paginaAtual}
          count={props.quantidadeDePaginas}
          variant="text"
          shape="rounded"
        />
      </div>
    );
  };

  const renderTabela = () => {
    return (
      <Table className={"tabela-gc "} id={props.id} striped bordered hover responsive>
        {renderTableHeader()}
        {!props.isLoading && renderTableBody()}
      </Table>
    );
  };

  return (
    <>
      <div className={`table-responsive`}>
        {renderTabela()}
        {!props.isLoading && props.quantidadeDeRegistros < 1 && renderNenhumRegistro()}
        {(props.quantidadeDePaginas > 1 && renderPagination) && renderPaginacao()}
      </div>
    </>
  );
};
